import styled from '@emotion/styled';
import Card from 'storybookConfig/stories/cells/Card';
import Heading from 'storybookConfig/stories/molecules/Heading';
import Body from 'storybookConfig/stories/molecules/Body';

const IconContainer = styled.div`
  width: 160px;
  height: 160px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Title = styled(Heading)`
  text-align: center;
  margin-bottom: 8px;
`;

const Subtitle = styled(Body)`
  text-align: center;
  color: ${({ theme }) => theme.color.bodyTextSecondary};
  margin-bottom: 24px;
`;

const ContentWrapper = styled.div`
  padding: 0 120px;
  text-align: center;
`;

interface ReturnPolicyPanelProps {
  iconSrc: string;
  iconAlt?: string;
}

const ReturnPolicyPanel = ({ iconSrc, iconAlt }: ReturnPolicyPanelProps) => (
  <Card>
    <ContentWrapper>
      <IconContainer>
        <img src={iconSrc} alt={iconAlt || 'Return Policy'} />
      </IconContainer>
      <Title variant="Headings/H3">Return Policy</Title>
      <Subtitle>Link to your return policy for potential retail partners to reference.</Subtitle>
    </ContentWrapper>
  </Card>
);

export default ReturnPolicyPanel;
